import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import "./Navigation.css";
import { modificaToken, modificaNome } from "../../actions/LoginActions";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";

class Navigation extends Component {
  state = {
    isOpen: false
  };

  logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  renderCadUsu = () => {
    const nvlAcesso = localStorage.getItem('nvl');

    if(nvlAcesso >= 3) {
      return (<UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          USUÁRIOS
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem
            onClick={() => this.props.history.push("/cadUsuario")}
          >
            Cadastro
          </DropdownItem>
          <DropdownItem
            onClick={() => this.props.history.push("/listaUsuarios")}
          >
            Lista
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>)
    }
  }
  
  render() {
    return (
      <BlockUi
        tag="div"
        blocking={this.props.showLoader}
        message="Por favor, aguarde"
      >
        <div>
          <Navbar color="dark" dark expand="md">
            <NavbarBrand href="/">Ativação</NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                {this.renderCadUsu()}
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    OLTS
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem
                      onClick={() => this.props.history.push("/cadOlt")}
                    >
                      Cadastro
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.props.history.push("/listaOlts")}
                    >
                      Lista
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    VLANS
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem
                      onClick={() => this.props.history.push("/cadastroVlans")}
                    >
                      Cadastro
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.props.history.push("/listaVlans")}
                    >
                      Lista
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    CAIXAS
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem
                      onClick={() => this.props.history.push("/cadastroCaixa")}
                    >
                      Cadastro
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.props.history.push("/listaCaixas")}
                    >
                      Lista
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    {this.props.nome}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={() => this.logout()}>
                      Sair
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Navbar>
          <div className="corpo container-fluid">{this.props.children}</div>
        </div>
      </BlockUi>
    );
  }
}

const mapStateToProps = state => ({
  token: state.LoginReducer.token,
  nome: state.LoginReducer.nome,
  showLoader: state.LoaderReducer.showLoader
});

export default connect(
  mapStateToProps,
  { modificaToken, modificaNome }
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js